import RcPagination from 'rc-pagination';
import { ReactNode } from 'react';

const PaginationItem = (page: number, type: string, element: ReactNode) => {
    switch (type) {
        case 'page': {
            return <div className="navigation-btns__btn">{page}</div>;
        }
        case 'prev': {
            return (
                <div className="navigation-btns__btn--prev">
                    <svg
                        className="icon"
                        width="12"
                        height="18"
                        viewBox="0 0 12 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M10 16.37L2 9l8-7.369"
                            stroke="#000"
                            strokeWidth="2"
                            strokeLinecap="square"
                        />
                    </svg>
                </div>
            );
        }
        case 'next': {
            return (
                <div className="navigation-btns__btn--next">
                    <svg
                        className="icon"
                        width="12"
                        height="18"
                        viewBox="0 0 12 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M10 16.37L2 9l8-7.369"
                            stroke="#000"
                            strokeWidth="2"
                            strokeLinecap="square"
                        />
                    </svg>
                </div>
            );
        }
        case 'jump-prev':
        case 'jump-next': {
            return <div className="navigation-btns__btn">...</div>;
        }
    }
    return element;
};

interface PaginationProps {
    pageSize: number;
    page: number;
    setPageSize: (size: number) => void;
    setPage: (page: number) => void;
    total: number;
}

const pageSizes = [10, 30, 50, 100];

function Pagination({ pageSize, page, setPageSize, setPage, total }: PaginationProps) {
    return (
        <div className="pagination-wrapper">
            <label>
                Показывать по: &nbsp;
                <select value={pageSize} onChange={(e) => setPageSize(parseInt(e.target.value))}>
                    {pageSizes.map((size) => (
                        <option key={size} value={size}>
                            {size}
                        </option>
                    ))}
                </select>
            </label>

            <span>&nbsp; Всего: {total} &nbsp;</span>

            <span style={{ margin: '0 0 0 auto' }}>
                <RcPagination
                    className="navigation-btns"
                    pageSize={pageSize}
                    current={page}
                    showLessItems
                    onChange={(page: number) => {
                        document.body.scrollTop = 0;
                        document.documentElement.scrollTop = 0;
                        setPage(page);
                    }}
                    total={total}
                    itemRender={PaginationItem}
                    showTitle={false}
                />
            </span>
        </div>
    );
}

export default Pagination;
